import React, {useContext} from "react";
import Chip from "@mui/material/Chip";
import {DynamicIcon} from "../../helper/getIcon";
import {ContentContext} from "../../ContentContext";

function Services() {
    const data = useContext(ContentContext);

    if (!data?.showSections.includes("extras")) {
        return null;
    }

    return (
        <section className={"extras"}>
            <h2 dangerouslySetInnerHTML={{__html: data?.extrasTitle}} />
            <div className={"extras-list"}>
                {data?.extrasContent.map((item, index) => (
                    <div key={index} className={"extra indented"}>
                        <div className={"extra-title"}>
                            <DynamicIcon iconLibrary={item?.iconLibrary} iconName={item?.iconName} />
                            <h2>{item?.title}</h2>
                        </div>
                        <div className={"extra-subtitle"}>
                            <Chip className={"chip"} variant="filled" size="medium" label={item?.subtitle} />
                        </div>
                        <div className={"extra-description"}>
                            <span dangerouslySetInnerHTML={{__html: item?.description}} />
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}

export default Services;
